import { useState } from "react";
import { ICON_NAMES, SpecimenIcon } from "../../lib/icons";

export const IconPicker = ({ value, onChange }) => {
  const [q, setQ] = useState("");
  const list = ICON_NAMES.filter((n) => n.toLowerCase().includes(q.toLowerCase()));
  return (
    <div data-testid="icon-picker">
      <input
        data-testid="icon-search-input"
        placeholder="Search icons (e.g. leaf, key)"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        className="lab-input w-full text-sm"
      />
      <div className="mt-2 grid max-h-44 grid-cols-8 gap-1 overflow-y-auto border border-slate-800 p-2">
        {list.map((name) => (
          <button
            type="button"
            key={name}
            title={name}
            data-testid={`icon-option-${name}`}
            onClick={() => onChange(name)}
            className={`flex aspect-square items-center justify-center border transition-colors ${value === name ? "border-emerald-400 bg-emerald-400/10 text-emerald-300" : "border-transparent text-slate-400 hover:border-cyan-400/40 hover:text-cyan-300"}`}
          >
            <SpecimenIcon name={name} size={20} />
          </button>
        ))}
      </div>
    </div>
  );
};
